import { render, staticRenderFns } from "./DocumentationView.vue?vue&type=template&id=3e20a292&scoped=true&"
import script from "./DocumentationView.vue?vue&type=script&lang=js&"
export * from "./DocumentationView.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationView.vue?vue&type=style&index=0&id=3e20a292&scoped=true&lang=css&"
import style1 from "./DocumentationView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e20a292",
  null
  
)

export default component.exports